import PropTypes from 'prop-types';

const ErrorMessage = ({ children }) => <div className="text-tiny text-danger mt-1">{children}</div>

PropTypes.propTypes = {
  children: PropTypes.node.isRequired
}

export default ErrorMessage;
